import { RouteComponentProps } from "react-router-dom";
import userStore, { IUserStore } from "./userStore";
import commonStore, { ICommonStore } from "./commonStore";
import filterStore, { IFilterStore } from "./filterStore";
import formatStore, { IFormatStore } from "./formatStore";
import notificationStore, { INotificationStore } from "./notificationStore";
import scannerStore, { IScannerStore } from "./scannerStore";
import settingsStore, { ISettingsStore } from "./settingsStore";
import symbolStore, { ISymbolStore } from "./symbolStore";

export const stores = {
    userStore,
    commonStore,
    filterStore,
    formatStore,
    notificationStore,
    scannerStore,
    settingsStore,
    symbolStore
};

export interface AppProps extends RouteComponentProps {
    commonStore?: ICommonStore;
    userStore?: IUserStore,
    filterStore?: IFilterStore,
    formatStore?: IFormatStore,
    notificationStore?: INotificationStore,
    scannerStore?: IScannerStore,
    settingsStore?: ISettingsStore,
    symbolStore?: ISymbolStore
}